<template>
    <div id="driver_commission_reports">
        <div class="ui buttons">
            <button class="ui basic grey button" @click.prevent="print">
                <i class="print icon"></i>{{ $t('ui.pages.driver_commission_reports.print')}}
            </button>
            <button class="ui basic grey button" @click.prevent="toggle_setting_panel">
                <i class="setting icon"></i>{{ $t('ui.pages.driver_commission_reports.setting')}}
            </button>
        </div>

        <transition name="fade" mode="out-in">
            <div class="ui segment" v-show="visibility.setting_panel">
                <table class="ui very basic table">
                    <thead>
                        <tr>
                            <th>{{ $t('ui.pages.driver_commission_reports.print_setting')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="ui checkbox">
                                <div class="ui checkbox">
                                    <input type="checkbox" v-model="settings.print.is_detailed_mode">
                                    <label>{{ $t('ui.pages.driver_commission_reports.detailed_mode')}}</label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </transition>

        <Filters></Filters>

        <div class="ui segment">
            <table class="ui celled compact table">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{ $t('models.attributes.driver_commission_reports.staff') }}</th>
                        <th>{{ $t('models.attributes.driver_commission_reports.begin_at') }}</th>
                        <th>{{ $t('models.attributes.driver_commission_reports.begin_at') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_reports.total_amount_of_commission') }}</th>
                        <th>{{ $t('models.attributes.driver_commission_reports.created_at') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="status == 'default' || status == 'fetching'">
                        <td colspan="7">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                    <DriverCommissionReport
                        v-if="status == 'initialized'"
                        :key="driver_commission_report.identity"
                        v-for="driver_commission_report in driver_commission_reports"
                        :driver_commission_report="driver_commission_report"
                        :is_detailed_mode="settings.print.is_detailed_mode">
                    </DriverCommissionReport>
                </tbody>
            </table>

            <Paginator
                :total_pages="pagination.total_pages"
                :current_page="pagination.current_page">
            </Paginator>
        </div>

    </div>
</template>

<script>
import DriverCommissionReport from "../.components/index/item.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import Filters from "../.components//filter/main.vue"

export default {
    name: "DriverCommissionReportsIndex",
    data() {
        return {
            status: "default",
            visibility: {
                setting_panel: false,
            },
            settings: {
                print: {
                    is_detailed_mode: false,
                }
            }
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.driver_commission_reports_module
        },
        driver_commission_reports() {
            return this.current_store.driver_commission_reports
        },
        pagination() {
            return this.current_store.pagination
        },
        is_selected() {
            return this.current_store.is_selected
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
        this.init()
        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
    },
    methods: {
        async init(is_first = true) {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.status = "default"
                    resolve()
                })
                await this.$store.dispatch('provider/driver_commission_reports_module/handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                    await this.$store.dispatch('provider/driver_commission_reports_module/handle_quick_filter_key')
                }
                await this.$store.dispatch('provider/driver_commission_reports_module/fetch_driver_commission_reports')
            } catch (e) {
                console.log("init error: ")
                console.log(e)
                this.$noty.error(
                    this.$t('ui.notifications.error.fetch__name', {
                        name: this.$t('models.driver_commission_reports'),
                        reason: e
                    })
                )
            } finally {
                this.status = "initialized"
            }
        },
        driver_commission_reports_filter() {
            console.log('driver_commission_reports_filter')
            try {
                this.$router.push({
                    name: this.$router.name,
                    query: this.$store.getters['provider/driver_commission_reports_module/filter_to_query'],
                })
            } catch (e) {
                console.log(e)
            }
        },
        multiple_select() {
            var items = _.filter(this.$children, e => {
                return e.$options._componentTag == "DriverCommissionReport"
            })
            _.forEach(items, (item_component, key) => {
                item_component.is_selected = this.is_selected
            })
        },
        async print() {
            var items = _.filter(this.$children, e => {
                return e.$options._componentTag == "DriverCommissionReport"
            })
            $("div#print").html("")
            await new Promise(resolve => {
                _.forEach(items, (item_component, key) => {
                    if (item_component.is_selected == true) {
                        $('div#print').append(item_component.$refs.printable)
                    }
                    if (key == (items.length - 1)) {
                        resolve()
                    }
                })
            })
            await new Promise(resolve => {
                window.print()
                resolve()
            })
        },
        toggle_setting_panel() {
            this.visibility.setting_panel = !this.visibility.setting_panel
        }
    },
    components: {
        Filters,
        DriverCommissionReport,
        Paginator,
    }
}
</script>

<style>
    .el-date-editor--datetimerange {
        display: block !important;
        height: auto !important;
        width: 240px !important;
    }
    .el-date-editor--datetimerange .el-range-input:first-child {
        display: block;
    }
    .el-date-editor--datetimerange .el-range-input {
        width: 90%;
    }
    .el-date-editor--datetimerange .el-range__close-icon {
        position: absolute;
        right: 2px;
        top: 0;
    }

</style>

<style media="screen">
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0
}
</style>
